import { useAuth } from 'core/contexts/auth/AuthContext'
import { Link, useLocation } from 'react-router-dom'
import { User } from 'react-feather';
import { PermissionsGate } from 'components/PermissionsGate';
import MenuSearchBar from 'components/uiComponents/MenuSearchBar';
import { menuData } from './menuData';
import palette from 'core/constant/palette';
import NotificationBell from './NotificationBell';
import AccountMenu from './AccountMenu';

/**
 * The desktop header navigation row.
 *
 * What was a 436-line file that mixed the navigation with a whole notification
 * subsystem, an account menu and their modals is now just the navigation: the
 * primary links, the location line, the search box, and a mount point for
 * <NotificationBell /> and <AccountMenu />. Each of those is self-contained and
 * fetches or reads what it needs itself, so this file is again about the header
 * layout alone (BLD-11).
 */
const NavBar = () => {
    const { user } = useAuth();
    const location = useLocation();

  return (
    <div className='mt-[31px] mb-[32px] h-[20px] w-full justify-between text-sm text-secondary font-normal absolute z-20 hidden lg:flex'>
        {/* The five main links were the height of their own text -- 20px -- which
            is the smallest target on the site and the one every visitor uses
            first. `py-3 -my-3` takes them to 44px and gives the space straight
            back to the layout, so nothing on the header moves. */}
        <div className='flex gap-[46px]'>
            {menuData?.map((item: any) => {
                if (item?.roles?.length === 0) {
                    return (
                        <Link to={item.path} key={item.id} className=' cursor-pointer flex items-center py-3 -my-3 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-gold'>
                            <p
                            className={`${location?.pathname?.includes('/quan-ly') && item.path.includes('/quan-ly')?'text-white font-bold' : location?.pathname === item.path? 'text-white font-bold' : ''}`}>
                                {item.title}
                            </p>
                        </Link>
                    )
                }else {
                    return (
                        <PermissionsGate user={user} scopes={item?.roles} key={item.id}>
                            <Link to={item.path} className=' cursor-pointer flex items-center py-3 -my-3 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-gold'>
                                <p
                                className={`${location?.pathname?.includes('/quan-ly') && item.path.includes('/quan-ly')?'text-white font-bold' : location?.pathname === item.path? 'text-white font-bold' : ''}`}>
                                    {item.title}
                                </p>
                            </Link>
                        </PermissionsGate>
                    )
                }
            })}
        </div>
        {/* The location line only appears from `xl` up. Below that the desktop
            row (links + a 300px search box + the account/login cluster) leaves
            the middle column too little room: at 1024px the fixed left padding
            here squeezed "Huyện Yên Thành, Nghệ An" into about 60px and it wrapped
            to four lines, and a plain nowrap would instead run it under the search
            box. At `xl` there is room for the centred line, so it returns whole
            (NAV-1). */}
        <div className={`hidden xl:flex flex-1 justify-start items-center whitespace-nowrap ${user ? 'pl-[90px]' : 'pl-[180px]'}`}>
            <span className=' text-sm font-light'>Huyện Yên Thành, Nghệ An</span>
        </div>
        <div className='flex gap-[18px] items-center'>
            <div>
                {!location?.pathname?.includes('/search') &&
                    <MenuSearchBar />
                }
            </div>
            <div className='flex gap-[18px] items-center'>
                {user && <NotificationBell />}
                {!user &&
                    // A `div` that called navigate(). It goes to a URL, so it is a
                    // link: reachable by Tab, openable in a new tab, and announced
                    // as a link rather than as two pieces of text.
                    <Link to='/login' className='flex items-center cursor-pointer py-3 -my-3 gap-[5px] rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-gold'>
                        <User size={24} color={palette.gold}/>
                        <p>Đăng nhập</p>
                    </Link>
                }
                {user && <AccountMenu />}
            </div>
        </div>
    </div>
  )
}

export default NavBar
